import axiosInstance from "../axiosClient";
import { dashboarduri, statusuri } from "../config";

export const getDetails = async (limit,start_key,start_date,end_date,search) => {
  let queryParams = [];
  if (limit) queryParams.push(`limit=${encodeURIComponent(limit)}`)
  if (start_date) queryParams.push(`start_date=${encodeURIComponent(start_date)}`)
  if (end_date) queryParams.push(`end_date=${encodeURIComponent(end_date)}`)
  if (start_key) queryParams.push(`start_key=${encodeURIComponent(JSON.stringify(start_key))}`);
  if (search) queryParams.push(`search=${encodeURIComponent(search)}`)

  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

  return await axiosInstance.get(`${dashboarduri}${queryString}`);
};


export const getStatus = async (start_date,end_date) =>{
    let queryParams = [];
    if (end_date) queryParams.push(`end_date=${encodeURIComponent(end_date)}`)
    if (start_date) queryParams.push(`start_date=${encodeURIComponent(start_date)}`)
    const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

    return await  axiosInstance.get(`${statusuri}${queryString}`)
}